export default __webpack_public_path__ + "static/media/graphic.6ed35703.jpg";